import React, { useEffect } from "react";
import Progressbar from "./Progressbar";
import AOS from "aos";
import "aos/dist/aos.css";

const skillLists = [
  {
    name: "ReactJS",
    percentage: 75,
  },
  {
    name: "JavaScript",
    percentage: 80,
  },
  {
    name: "HTML5",
    percentage: 80,
  },
  {
    name: "CSS3",
    percentage: 78,
  },
  {
    name: "Bootstrap",
    percentage: 70,
  },
  {
    name: "Tailwind CSS",
    percentage: 70,
  },
  {
    name: "PHP",
    percentage: 80,
  },
  {
    name: "Laravel",
    percentage: 80,
  },
];

const Skills = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const renderedSkill = skillLists.map(({ name, percentage }) => {
    return <Progressbar key={name} name={name} percentage={percentage} />;
  });

  return (
    <div
      className="w-full flex lg:mt-5 flex-col items-center font-montserrat pb-3"
      data-aos="fade-right"
    >
      <h3 className="text-2xl font-semibold mb-3">Skills</h3>
      <div className="flex md:flex-row lg:flex-row lg:w-11/12 xl:w-8/12 flex-col w-4/5 items-center lg:flex-wrap md:flex-wrap">
        {renderedSkill}
      </div>
    </div>
  );
};

export default Skills;
